<template>
  <div class="px-3 md:px-0">
    <h1 class="text-lg font-bold">Simulacros</h1>
    <div class="text-neutral-700 mt-5 space-y-4">
      <p>
        Durante el simulacro, no se mostrarán las opciones correctas ni las
        explicaciones de las respuestas. Sin embargo, una vez que hayas
        completado el simulacro, tendrás la oportunidad de revisar los
        ejercicios y ver las respuestas junto con sus explicaciones
        correspondientes. Esto te permitirá analizar tus respuestas y comprender
        mejor los conceptos detrás de cada ejercicio.
      </p>
    </div>

    <MobList :items="items" class="mt-5" />
  </div>
</template>

<script>
import { MobList } from "@/views/V2/components";
import {getStudentStatusSimulacrum} from "@/services/simulacrum.service";
import {hasPassedDate} from "@/Utils/utils";

export default {
  name: "SimulacrumIntro",
  components: {
    MobList,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  watch: {
    course: {
      immediate: true,  // dispara también al montar
      async handler(newCourse) {
        if (newCourse.id == null) return;
        
        let courseId = this.$route.params.id;
        if (courseId) {
          let simulacrums = await getStudentStatusSimulacrum(courseId);

          for (const element of simulacrums) {
            let currentState = '';
            let link = element.id.toString();

            if (!this.course.enrolled) {
              currentState = 'disabled';
              link = `/course/${courseId}/simulacrums`;
            } else if (element.finished) {
              currentState = 'completed';
              link = `/course/${courseId}/simulacrums/${element.id.toString()}/results`;
            } else if (!hasPassedDate(element.startDate) || hasPassedDate(element.endDate)) {
              currentState = 'disabled';
              link = `/course/${courseId}/simulacrums`;
            }

            this.items.push(
              {
                label: element.title,
                icon: "iconamoon:eye-light",
                link: link,
                state: currentState,
                isPremium: element.isPremium
              },
            )
          }
        }
      },
    }
  },  
};
</script>
